module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order/order.component.css
// module id = ./src/app/order/order.component.css
// module chunks = main